import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { Spinner } from "@/components/ui-kit/Spinner";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen grid place-items-center bg-background"
      >
        <Spinner />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return children;
}
